import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f39176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-ee-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "body-main" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = {
  key: 3,
  class: "search"
}
const _hoisted_10 = { class: "search-bar" }
const _hoisted_11 = { class: "icon-hm" }
const _hoisted_12 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_13 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 4,
  class: "error"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "LawID email", -1))
const _hoisted_19 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Last name", -1))
const _hoisted_24 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "First name", -1))
const _hoisted_28 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_31 = {
  key: 5,
  class: "radio-group",
  style: {"width":"300px"}
}
const _hoisted_32 = { class: "radio" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Active")
], -1))
const _hoisted_34 = { class: "radio" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text nowrap" }, "Inactive")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Firm name", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Address", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_42 = { style: {"display":"flex","justify-content":"space-between","align-items":"start"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fieldname" }, "Telephone number", -1))
const _hoisted_44 = { style: {"display":"flex","justify-content":"space-between","width":"100%","align-items":"center"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-field2" }, "+61", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fieldname" }, "Membership type", -1))
const _hoisted_48 = { class: "dropdown-menu-wrap mt-1" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: ""
}, "-- Please select --", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode("Required field. ")
], -1))
const _hoisted_52 = { class: "mt-4" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Publish on Web", -1))
const _hoisted_54 = { class: "checkbox-button" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ])
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fieldname" }, "Proof of External Examiner Course Completion", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" File required. ")
], -1))
const _hoisted_58 = { class: "file-list mb-2" }
const _hoisted_59 = { class: "file-name" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-pdf" }, null, -1))
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-info-circle",
    style: {"font-size":"20px","color":"var(--ls-slate)"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Please be aware that the supported file formats include .PDF, .DOC, .DOCX, .XLS, .XLSX, .RTF, .JPG and .PNG. You may upload up to five files")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Reason for termination:", -1))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 0,
  class: "validation-msg error"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_70 = { class: "controls" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_PostcodeSearch = _resolveComponent("PostcodeSearch")
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[21] || (_cache[21] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.line1Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.selectedEE)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, "Law ID"))
            : (_openBlock(), _createElementBlock("h4", _hoisted_6, "Search")),
          (_ctx.selectedEE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    maxLength: "75",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedEE.lawId) = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.selectedEE.lawId]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Search for LawID or email",
                    maxLength: "75",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.searchText) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchText]
                  ]),
                  _createElementVNode("span", _hoisted_11, [
                    (_ctx.isSearching)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                      : (_openBlock(), _createElementBlock("i", _hoisted_13))
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-secondary sml ml-2",
                  disabled: _ctx.searchText.length === 0 || _ctx.isSearching,
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchLawIDforEE()))
                }, "Search", 8, _hoisted_14)
              ])),
          (_ctx.invalidLawIdEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(" Invalid LawID or email ")
              ]))
            : _createCommentVNode("", true),
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("div", {
            class: _normalizeClass(["input-box", this.email === '' && _ctx.submitPressed ? 'error': ''])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              maxLength: "75",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.email) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            (this.email === '' && _ctx.submitPressed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createTextVNode(" Required field. ")
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _hoisted_21,
          _createElementVNode("div", {
            class: _normalizeClass(["names", this.lastName === '' && _ctx.submitPressed ? 'error': '']),
            style: {"display":"flex","justify-content":"space-between"}
          }, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", this.lastName === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.lastName) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.lastName]
                ])
              ], 2),
              (this.lastName === '' && _ctx.submitPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(" Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", this.firstName === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.firstName) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.firstName]
                ])
              ], 2),
              (this.firstName === '' && _ctx.submitPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createTextVNode(" Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _hoisted_30,
          (_ctx.inEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "inactive",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.inactive) = $event)),
                    value: false
                  }, null, 512), [
                    [_vModelRadio, _ctx.inactive]
                  ]),
                  _hoisted_33
                ]),
                _createElementVNode("label", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "inactive",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.inactive) = $event)),
                    value: true
                  }, null, 512), [
                    [_vModelRadio, _ctx.inactive]
                  ]),
                  _hoisted_35
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_36,
          _hoisted_37,
          _createElementVNode("div", {
            class: _normalizeClass(["input-box", this.firmName === '' && _ctx.submitPressed ? 'error': ''])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Firm name",
              maxLength: "75",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.firmName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.firmName]
            ])
          ], 2),
          _hoisted_38,
          _hoisted_39,
          _createElementVNode("div", {
            class: _normalizeClass(["input-box", this.address === '' && _ctx.submitPressed ? 'error': ''])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Address",
              maxLength: "75",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.address]
            ])
          ], 2),
          _hoisted_40,
          _createVNode(_component_PostcodeSearch, {
            suburbStatePostcode: _ctx.suburbStatePostcode,
            "onUpdate:suburbStatePostcode": _cache[10] || (_cache[10] = $event => ((_ctx.suburbStatePostcode) = $event)),
            suburbError: _ctx.suburbError,
            "onUpdate:suburbError": _cache[11] || (_cache[11] = $event => ((_ctx.suburbError) = $event)),
            onUpdateSuburb: _ctx.updateSuburb
          }, null, 8, ["suburbStatePostcode", "suburbError", "onUpdateSuburb"]),
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box col-6", ((!_ctx.phoneNumber || _ctx.phoneNumber === '') && (_ctx.dirtyFields[3] || _ctx.submitPressed)) ? 'error': ''])
            }, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "15",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.phoneNumber) = $event)),
                  onChange: _cache[13] || (_cache[13] = $event => (_ctx.dirtyFields[3] = true)),
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, _ctx.phoneNumber]
                ])
              ]),
              _hoisted_46
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu col-6 ml-4", (!_ctx.selectedMembershipType && (_ctx.dirtyFields[4] || _ctx.submitPressed)) ? 'error': ''])
            }, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.selectedMembershipType) = $event)),
                  onChange: _cache[15] || (_cache[15] = $event => (_ctx.dirtyFields[4] = true))
                }, [
                  _hoisted_49,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membershipStatusTypes, (membershipT) => {
                    return (_openBlock(), _createElementBlock("option", { value: membershipT }, _toDisplayString(membershipT.name), 9, _hoisted_50))
                  }), 256))
                ], 544), [
                  [_vModelSelect, _ctx.selectedMembershipType]
                ])
              ]),
              _hoisted_51
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("label", _hoisted_54, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.publishOnWeb) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.publishOnWeb]
              ]),
              _hoisted_55
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["file-upload mt-4", (!_ctx.inEditMode && _ctx.uploadedFileList?.length == 0 && (_ctx.dirtyFields[5] || _ctx.submitPressed)) ? 'error': ''])
            }, [
              _hoisted_56,
              _createVNode(_component_FileDragAndDrop, {
                disabled: _ctx.uploadedFileList.length == 5,
                uploading: _ctx.uploading,
                ref: "fileDropAndDrop",
                onFileInputChanged: _cache[17] || (_cache[17] = $event => {_ctx.fileListChanged($event); _ctx.dirtyFields[5] = true}),
                numFileLimit: 5,
                fileSizeLimit: 50
              }, null, 8, ["disabled", "uploading"]),
              _hoisted_57,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedFileList, (f) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createTextVNode(" " + _toDisplayString(f.fileName), 1)
                  ]),
                  (_ctx.inEditMode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-outline sml",
                        onClick: _withModifiers($event => (_ctx.deleteFile(f.id, true)), ["prevent"])
                      }, "Delete", 8, _hoisted_61))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-outline sml",
                        onClick: _withModifiers($event => (_ctx.deleteFile(f.id, false)), ["prevent"])
                      }, "Delete", 8, _hoisted_62))
                ]))
              }), 256))
            ], 2)
          ]),
          _hoisted_63,
          _hoisted_64
        ]),
        _hoisted_65,
        (_ctx.selectedEE && _ctx.inactive)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_66,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.reasonForInactive) = $event)),
                class: _normalizeClass(_ctx.submitPressed && _ctx.reasonForInactive == '' ? 'error' :''),
                style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                maxlength: 5000,
                placeholder: "Enter reason",
                disabled: !_ctx.inEditMode
              }, null, 10, _hoisted_67), [
                [_vModelText, _ctx.reasonForInactive]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["footnote", [_ctx.reasonForInactive?.length === 5000 ? 'full' : '']])
              }, _toDisplayString(_ctx.reasonForInactive?.length || 0) + "/5000 characters ", 3),
              (_ctx.reasonForInactive == '' & _ctx.submitPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _hoisted_69,
                    _createTextVNode(" Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_70, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.isLoading,
            onClick: _cache[19] || (_cache[19] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, "Cancel", 8, _hoisted_71),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: _ctx.isLoading,
            onClick: _cache[20] || (_cache[20] = $event => (_ctx.addEE()))
          }, _toDisplayString(_ctx.btnText), 9, _hoisted_72)
        ])
      ]),
      footer: _withCtx(() => []),
      _: 1
    }),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmDialogue",
      modalOpened: true
    }, null, 512)
  ]))
}